import React, {useState, useMemo} from "react"
import nprogress from "nprogress"
import swal from "sweetalert"
import {useQuery} from "react-query"
import useAuth from "auth/useAuth"
import useRescuers from "hooks/useRescuers"
import Rescuer from "components/Rescuer"
import "./TagAssign.css"

export default function TagEditor(props) {

    const {auth, API} = useAuth()
    const {filter, refetch} = useRescuers()
    const {tags} = props
    const [tag, setTag] = useState("")
    const [query, setQuery] = useState("")

    const tagged = useMemo(() => {
        if (!tag) return []
        return filter(`#${tag}`)
    }, [filter, tag])

    const search = useMemo(() => {
        if (!query) return []
        const taggedUsernames = new Set(tagged.map(user => user.username))
        return filter(query).filter(user => !taggedUsernames.has(user.username))
    }, [filter, query])

    const addTag = (rescuer) => {
        if (!tag) {
            swal("Greška", "Mora da se izabere tag koji hoćeš da dodaš", "error")
            return
        }
        nprogress.start()
        auth(API.rescuersIdTagsTagPut, {id: rescuer.username, tag: tag}).then(response => {
            refetch()
            nprogress.done()
        }).catch(response => {
            console.log("ERROR", response)
            swal("Greška", "Može samo administrator", "error")
            nprogress.done()
        })        
    }
    
    const removeTag = (rescuer) => {
        nprogress.start()
        auth(API.rescuersIdTagsTagDelete, {id: rescuer.username, tag: tag}).then(response => {
            refetch()
            nprogress.done()
        }).catch(response => {
            console.log("ERROR", response)
            swal("Greška", "Može samo administrator", "error")
            nprogress.done()
        }) 
    }
    
    

    return <section id="tag-assign">
        <h3>Dodeljivanje tagova</h3>
        <p>
            Brzo dodeljivanje i uklanjanje tagova bez potrebe za pojedinačnim otvaranjem profila spasilaca.<br/>
            Jednostavno izaberi tag koji želiš dodeliti ili ukloniti i izaberi spasioce.
        </p>
        
        <select value={tag} onChange={event => setTag(event.target.value)}>
            <option value="">Izaberi tag</option>
            {tags.map(tag => <option key={tag.name} value={tag.name}>{tag.name}</option>)}
        </select>
        
        {!!tag && <>            
            <hr/>
            
            <div>
                <h4>Spasioci koji imaju tag <code>{tag}</code></h4>
                <p>Klik na spasioca skida tag</p>
                {tagged && tagged.map(rescuer => <Rescuer key={rescuer.username} rescuer={rescuer} onClick={removeTag}/>)}
                {!tagged?.length && <div>Nema ni jedan</div>}
            </div>
            
            <hr/>
            
            <div>
                <h4>Spasioci kojima želiš da dodaš tag</h4>
                <p>Pretraži spasioce i onda dodeli tag <code>{tag}</code> klikom</p>
                
                <input type="text" placeholder="Pretraži spasioce kojima hoćeš da dodaš tag..." value={query} onChange={event => setQuery(event.target.value)}/>
                <div>
                    {search && search.map(rescuer => <Rescuer key={rescuer.username} rescuer={rescuer} onClick={addTag}/>)}
                </div>
            </div>
        </>}
    </section>
    
}
